import React, { useState, useEffect } from 'react';
import { fetchWithAuth } from '../../utils/api';
import { useAuth } from '../../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import Edit from '../../images/edit.svg';
import Save from '../../images/save.svg';
import './Dashboard.css';

export default function Dashboard() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const [editName, setEditName] = useState(false);
  const [editEmail, setEditEmail] = useState(false);
  const [editPassword, setEditPassword] = useState(false);

  // Загрузка профиля
  useEffect(() => {
    async function load() {
      if (!user?.id) return;
      try {
        const res = await fetchWithAuth(`/api/user/${user.id}`);
        const data = await res.json();
        setName(data.username);
        setEmail(data.email);
      } catch (err) {
        console.error('Не удалось загрузить профиль:', err);
      }
    }
    load();
  }, [user]);

  // Сохранить имя
  const handleNameChange = async () => {
    try {
      const res = await fetchWithAuth(`/api/user/${user.id}`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username: name }),
      });
      if (!res.ok) throw new Error('Ошибка обновления имени');
      setEditName(false);
    } catch (err) {
      console.error(err);
      alert(err.message);
    }
  };

  // Сохранить email
  const handleEmailChange = async () => {
    try {
      const res = await fetchWithAuth(`/api/user/${user.id}`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });
      if (!res.ok) throw new Error('Ошибка обновления email');
      setEditEmail(false);
      await sendEmailConfirmation(email);
    } catch (err) {
      console.error(err);
      alert(err.message);
    }
  };

  // Сохранить пароль
  const handlePasswordChange = async () => {
    try {
      const res = await fetchWithAuth(`/api/user/${user.id}`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ password }),
      });
      if (!res.ok) throw new Error('Ошибка обновления пароля');
      setEditPassword(false);
      await sendEmailConfirmation(email);
    } catch (err) {
      console.error(err);
      alert(err.message);
    }
  };

  const sendEmailConfirmation = async (email) => {
    // тут можно реальный POST для отправки письма
    console.log(`Confirmation email sent to ${email}`);
  };

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  const goToMainContent = () => {
    navigate('/main');
  };

  return (
    <div className="dashboard-container">
      <h2>Профиль</h2>

      <div className="input-field">
        <label htmlFor="name">Имя:</label>
        <input
          id="name"
          type="text"
          value={name}
          disabled={!editName}
          onChange={e => setName(e.target.value)}
        />
        {editName ? (
          <img src={Save} alt="Save" onClick={handleNameChange} />
        ) : (
          <img src={Edit} alt="Edit" onClick={() => setEditName(true)} />
        )}
      </div>

      <div className="input-field">
        <label htmlFor="email">Email:</label>
        <input
          id="email"
          type="email"
          value={email}
          disabled={!editEmail}
          onChange={e => setEmail(e.target.value)}
        />
        {editEmail ? (
          <img src={Save} alt="Save" onClick={handleEmailChange} />
        ) : (
          <img src={Edit} alt="Edit" onClick={() => setEditEmail(true)} />
        )}
      </div>

      <div className="input-field">
        <label htmlFor="password">Пароль:</label>
        <input
          id="password"
          type="password"
          value={password}
          disabled={!editPassword}
          onChange={e => setPassword(e.target.value)}
        />
        {editPassword ? (
          <img src={Save} alt="Save" onClick={handlePasswordChange} />
        ) : (
          <img src={Edit} alt="Edit" onClick={() => setEditPassword(true)} />
        )}
      </div>

      <div className="button-container">
        <button className="logout-button" onClick={handleLogout}>
          Выйти
        </button>
        <button className="main-content-button" onClick={goToMainContent}>
          Перейти к расчётам
        </button>
      </div>
    </div>
  );
}
